class CartPopup extends HTMLElement {
  constructor() {
    super();
    this.initPopup();
  }

  initPopup() {
    this.querySelector('.cart-popup_close').addEventListener('click', this.closePopup.bind(this));
  }

  openPopup() {
    this.classList.add('open');
  }

  closePopup() {
    this.classList.remove('open');
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section => {
      document.querySelector(section.selector).innerHTML = 
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));
    this.initPopup();
    this.openPopup();
  }

  getSectionsToRender() {
    return [
      {
        id: 'header',
        selector: `.cart-popup_wrapper`,
      },
      {
        id: 'header',
        selector: `.cart-item-count`,
      },
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

}

customElements.define('cart-popup', CartPopup);